import React from 'react';
import Image from 'next/image';
import EmptyImage from '@/assets/job-title/empty.png';

const HideChart = (props: {
  isHide: boolean;
  hideTitle: string;
  children: React.ReactNode;
}) => {
  const { isHide, hideTitle, children } = props;
  if (isHide) {
    return (
      <div className="w-full h-full p-4 tablet:p-6">
        <p className="text-sm text-black/85 font-semibold mb-5">{`抱歉，${hideTitle}暂无数据`}</p>
        <div className="relative h-[156px] w-[156px]">
          <Image
            src={EmptyImage}
            alt="empty chart"
            fill
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
    );
  }
  return <>{children}</>;
};

export default HideChart;
